import type { ComponentProps } from 'react';

import { cn } from '../cn';

export type VideoPlayerProps = ComponentProps<'div'> & {
  src: string;
};

export function VideoPlayer({ src, className }: VideoPlayerProps) {
  return (
    <div className={cn('overflow-hidden rounded-tr-lg', className)}>
      <video
        src={src}
        controls
        className="max-h-64 w-full bg-slate-600"
        preload="metadata"
      />
    </div>
  );
}
